import { render } from "./AcademicWeekendPreSchool.vue?vue&type=template&id=18d04e18&scoped=true"
import script from "./AcademicWeekendPreSchool.vue?vue&type=script&lang=js"
export * from "./AcademicWeekendPreSchool.vue?vue&type=script&lang=js"

import "./AcademicWeekendPreSchool.vue?vue&type=style&index=0&id=18d04e18&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d04e18"]])

export default __exports__